






















































import { Vue, Component, Prop, Inject } from "vue-property-decorator";
import { IBasketProduct } from "@/models/baskets";
import { IBasketProviderData } from "@/models/providers/baskets";

@Component({
  components: {
    "product-image": () =>
      import("@/components/app/global/products/productImage.vue"),
    "express-basket-item-details": () =>
      import(
        "@/components/app/global/baskets/basket/express/basketItems/expressBasketItemDetails.vue"
      )
  }
})
export default class BasketItemDetailsShow extends Vue {
  // Inject

  @Inject({ from: "basketProviderData" })
  public readonly basketProviderData!: () => IBasketProviderData;

  // Props

  @Prop({ required: true })
  public basketItem!: IBasketProduct;

  @Prop({ required: true })
  public brandTaxType!: number;

  // Computed

  public get $basketData() {
    return this.basketProviderData();
  }

  public get basketItemName() {
    return this.$_.compact([
      this.$_.get(this.basketItem, "product.name_translated") ||
        this.$_.get(this.basketItem, "product.name"),
      this.$_.get(this.basketItem, "service_identifier")
        ? `(${this.$_.get(this.basketItem, "service_identifier")})`
        : null
    ]).join(" ");
  }

  public get basketItemCategory() {
    return (
      this.basketItem.product.category.name_translated ||
      this.basketItem.product.category.name
    );
  }
}
